export default __webpack_public_path__ + "static/media/s1-icon-2.d1a1f5b1.svg";